import { Wrap, WrapItem } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { IconType } from "react-icons";
import { FiClock, FiFileText, FiInbox, FiLayers, FiShoppingCart } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useSub } from "../subscription/useSub";
import { useProcurementTerms } from "../terminology/useProcurementTerms";
import { urls } from "../../urls";
import { LinkCard } from "./LinkCard";
import type { ListLink } from "./listResults";

const ICON_BY_TOOL: Record<string, IconType> = {
  listBuyerEvents: FiShoppingCart,
  listContractReports: FiFileText,
  getProjects: FiLayers,
  listNeeds: FiInbox,
  listMyUpcomingDeadlines: FiClock,
};

export const ListLinks = ({ lists }: { lists: ListLink[] }) => {
  const { t } = useTranslation();
  const terms = useProcurementTerms();
  const navigate = useNavigate();
  const { canAssessNeeds } = useSub();
  const listName: Record<string, string> = {
    listBuyerEvents: terms.procurementList,
    listContractReports: t("Contracts"),
    getProjects: t("Projects"),
    listNeeds: t("Needs"),
    listMyUpcomingDeadlines: t("Deadlines"),
  };
  const opened = lists.map((list) =>
    list.tool === "listNeeds" && !canAssessNeeds ? { ...list, path: urls.app.needs.mine } : list,
  );
  const byPath = new Map(opened.map((list) => [list.path, list]));
  return (
    <Wrap spacing="2">
      {Array.from(byPath.values()).map((list) => (
        <WrapItem key={list.path}>
          <LinkCard
            icon={ICON_BY_TOOL[list.tool]}
            label={listName[list.tool] ?? list.tool}
            sublabel={
              list.shown < list.total
                ? t("Showing the first {{shown}} of {{total}}", { shown: list.shown, total: list.total })
                : t("{{count}} hits", { count: list.total })
            }
            onOpen={() => navigate(list.path)}
          />
        </WrapItem>
      ))}
    </Wrap>
  );
};
